import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const CtaBanner = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 md:py-32 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        <div
          className={`relative bg-[#1B2A4A] rounded-3xl overflow-hidden transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Background image */}
          <div className="absolute inset-0 opacity-20">
            <img
              src="https://public.readdy.ai/ai/img_res/77747e207eca6b97e48ab97b5264aeda.jpg"
              alt=""
              className="w-full h-full object-cover object-center"
            />
          </div>
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B2A4A] via-[#1B2A4A]/95 to-[#1B2A4A]/80" />
          {/* Accent circle */}
          <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#E8521A]/15 -translate-y-1/2 translate-x-1/3 pointer-events-none" />
          <div className="absolute bottom-0 right-1/4 w-64 h-64 rounded-full bg-[#E8521A]/8 translate-y-1/2 pointer-events-none" />

          <div className="relative z-10 px-10 md:px-20 py-16 md:py-20 flex flex-col md:flex-row items-center justify-between gap-10">
            <div className="max-w-xl">
              <div className="flex items-center gap-3 mb-6">
                <span className="w-10 h-1 bg-[#E8521A] rounded-full" />
                <span
                  className="text-[#E8521A] text-sm font-bold tracking-widest uppercase"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  Get Started
                </span>
              </div>
              <h2
                className="text-3xl md:text-4xl font-black text-white leading-tight mb-5"
                style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '-0.03em' }}
              >
                프로젝트 검토부터<br />시작하세요
              </h2>
              <p
                className="text-white/60 text-lg leading-relaxed"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                지반조사, 계측, 안전진단 관련 문의를 남겨주시면<br />
                전문가가 신속하게 검토 후 연락드립니다.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 shrink-0">
              <Link
                to="/contact"
                className="group inline-flex items-center justify-center gap-3 bg-[#E8521A] text-white font-bold text-lg px-10 py-5 rounded-full hover:bg-[#d04515] transition-all duration-200 whitespace-nowrap"
              >
                견적 의뢰하기
                <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/solution"
                className="inline-flex items-center justify-center gap-3 bg-white/10 border-2 border-white/25 text-white font-bold text-lg px-10 py-5 rounded-full hover:bg-white/20 hover:border-white/40 transition-all duration-200 whitespace-nowrap"
              >
                솔루션 보기
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
